import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'inscricoes-silent-refresh-handler',
  templateUrl: './silent-refresh-handler.component.html',
  styleUrls: ['./silent-refresh-handler.component.scss'],
})
export class SilentRefreshHandlerComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    // This component is used to handle login via popup
    ;(window.opener || window.parent).postMessage(location.hash || '#' + location.search, location.origin)
  }
}
